import { useState, useEffect } from "react";
import { Typography, TextField, Autocomplete, Button } from "@mui/material";
import { StyledContainer } from "../../style/Admin/Suggestions";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Colors } from "../../style/theme/index.js";
import DashboardHeader from "../../components/Common/DashboardHeader";

import {
  suggestionListforUser,
  suggestionListforCourse,
  addSuggestions,
} from "../../services/suggestionServices";

const Suggestion = () => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [coursesData, setCoursesData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await suggestionListforUser();
         if (response.success) {
          setUsersData(response.data);
        }
      } catch (error) {
        toast.error("An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await suggestionListforCourse();
         if (response.success) {
          setCoursesData(response.data);
        }
      } catch (error) {
        toast.error("An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  const handleCourseChange = (event, newValues) => {
    const selectedCourseObjects = newValues
      .map((name) => {
        const course = coursesData.find((c) => c.name === name);
        return course ? { id: course.id, name: course.name } : null;
      })
      .filter(Boolean);
    setSelectedCourses(selectedCourseObjects);
  };

  const handleSave = async () => {
    try {
      const payload = {
        suggestions: {
          courseIds: selectedCourses.map((course) => course.id),
          userIds: selectedUsers.map((user) => user.id),
        },
      };

      const response = await addSuggestions(payload);

      if (response.success) {
        toast.success("Suggestions saved successfully!");
        
        setSelectedUsers([]);
        setSelectedCourses([]);
      } else {
        toast.error("Failed to save suggestions");
      }
    } catch (error) {
      toast.error("An error occurred while saving suggestions");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <StyledContainer maxWidth="md">
      <DashboardHeader title="Suggestions" />
      <Typography className="textup" variant="h6" gutterBottom>
        Select Users
      </Typography>

      <div className="section">
        <Autocomplete
          multiple
          options={usersData}
          getOptionLabel={(option) => {
            const sameNameUsers = usersData.filter(
              (u) => u.name.toLowerCase() == option.name.toLowerCase()
            );
            return sameNameUsers.length > 1
              ? `${option.name} (ID: ${option.id})`
              : option.name;
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          value={selectedUsers}
          onChange={(event, newValues) => {
            setSelectedUsers(newValues);
          }}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
               placeholder="Type user name..."
            />
          )}
        />
      </div>

      {selectedUsers.length > 0 && (
        <div className="section">
          <Typography variant="h6" gutterBottom>
            Suggest Courses
          </Typography>

          <Autocomplete
            multiple
            options={coursesData.map((course) => course.name)}
            value={selectedCourses.map((course) => course.name)}
            onChange={handleCourseChange}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                 placeholder="Type course name..."
              />
            )}
          />
          <div className="button-container">
            <Button
              className="button"
              variant="contained"
              onClick={handleSave}
              disabled={selectedCourses.length === 0}
            >
              Save Suggestions
            </Button>
          </div>
        </div>
      )}

      <ToastContainer autoClose={3000} />
    </StyledContainer>
  );
};

export default Suggestion;




